import {
  Mutation,
  ReactivationChallengeError,
  Typenames,
} from '@varo/graphql-schema-types';
import { useCallback, useEffect, useState } from 'react';
import StartReactivationChallenges from 'services/graphql/mutations/Reactivation/StartReactivationChallenges';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';
import { CombinedError, OperationResult } from 'urql';

export function useReactivationChallenges() {
  const [{ fetching }, executeMutation] = useCancellableMutation<
    Mutation,
    Record<string, never>
  >(StartReactivationChallenges);

  const [challengeId, setChallengeId] = useState<string | null>(null);
  const [error, setError] = useState<
    ReactivationChallengeError | CombinedError | Error | null
  >(null);

  const fetchData = useCallback(async () => {
    try {
      const result: OperationResult<Mutation> = await executeMutation({});

      if (result.data) {
        const challengeResult = result.data.startReactivationChallenges;

        if (
          challengeResult?.__typename === Typenames.ReactivationChallengeError
        ) {
          setError(challengeResult);
          setChallengeId(null);
        } else if (
          challengeResult?.__typename === Typenames.ReactivationChallengeSuccess
        ) {
          setChallengeId(challengeResult.challengeId);
          setError(null);
        }
      } else {
        setError(result.error as Error);
      }
    } catch (error) {
      setError(error as Error);
    }
  }, [executeMutation]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return {
    isLoading: fetching,
    challengeId,
    error,
    refetch: fetchData,
  };
}

export default useReactivationChallenges;
